import React from "react";
import classNames from "classnames";
import style from "./styles/loaders.module.scss";

/**
 * Рендерит компонент блока-лоадера с необязательным размером.
 *
 * @param height - Высота загрузчика в пикселях, по умолчанию - 48.
 * @return {JSX.Element} Компонент блочного загрузчика.
 */
const BlockLoader = ({ height = 48, className = "" }) => {
  const correctHeight = typeof height === "number" ? height : 48;

  const loaderClasses = classNames(style.loader, className);

  return (
    <div className={loaderClasses} style={{ height: `${correctHeight}px` }} />
  );
};

export default BlockLoader;
